// extracted by mini-css-extract-plugin
module.exports = {"container":"Lottery_container__2DhIF","stats":"Lottery_stats__3O_-k"};